import React from 'react';
import ControlComponent from '../ui/ControlComponent/ControlComponent';

export const getControlComponent = (renderProps) => {
  return (props) => {
    return (
      <ControlComponent
        {...props}
        {...renderProps}
      />
    );
  };
};
